"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("./ContextPanelFull.css");
function ContextPanelFull({ children }) {
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ id: "context-panel-full" }, { children: children }));
}
exports.default = ContextPanelFull;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGV4dFBhbmVsRnVsbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3Byb2plY3QvY29udGV4dC9Db250ZXh0UGFuZWxGdWxsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSxrQ0FBZ0M7QUFNaEMsU0FBd0IsZ0JBQWdCLENBQUMsRUFBRSxRQUFRLEVBQTBCO0lBQzNFLE9BQU8sOENBQUssRUFBRSxFQUFDLG9CQUFvQixnQkFBRSxRQUFRLElBQU8sQ0FBQztBQUN2RCxDQUFDO0FBRkQsbUNBRUMifQ==